import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ExcelReader from 'components/common/FileController/ExcelReader';
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { ConfigProvider, Table, Pagination, Button, Select, DatePicker, Tooltip, Tag } from 'antd';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
moment.locale('ko');

@inject('settleStore')
@observer
class SettleList extends Component {

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.settleStore.disSettleList(pageIdx);
  };

  onSearch = () => {
    this.props.settleStore.disSettleList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const { cGbn } = this.props;
    const {
      valCondition,
      onChangValue,

      settleList,
      pageInfo,
      disSettleList,

      totalPrice,
    } = this.props.settleStore;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: 140, align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '구매/반품확정일', dataIndex: 'confirmDate', width: 140, align: 'center',
        render: (item, record) => {return(
          item !== undefined && item !== null &&
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '주문번호', dataIndex: 'orCartNo', width: 250, align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },
      { title: '주문상태', dataIndex: 'orStat', width: 140, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "1" && <Fragment>승인대기</Fragment>}
            {item === "2" && <Fragment>승인완료</Fragment>}
            {(item === "3") &&
            ((record.rejectReason !== undefined && record.rejectReason !== null && record.rejectReason !== '')
              ? <Tooltip placement="topLeft" title={record.rejectReason}>
                  <span style={{color: 'blue'}}>승인반려</span>
                </Tooltip>
              : <Fragment>승인반려</Fragment>)
            }
            {item === "4" && <Fragment>배송준비</Fragment>}
            {item === "5" && <Fragment>배송중</Fragment>}
            {item === "6" && <Fragment>구매확정</Fragment>}
            {item === "7" && <Fragment>반품신청</Fragment>}
            {item === "8" && <Fragment>반품승인</Fragment>}
            {item === "9" && <Fragment>반품반려</Fragment>}
          </Fragment>
        )}
      },
      { title: '지사', dataIndex: 'orBranchNm', width: 140, align: 'center' },
      { title: '센터', dataIndex: 'orCeNm', width: 160, align: 'center' },
      { title: '직무', dataIndex: 'orJobNm', width: 150, align: 'center' },
      { title: '성별', dataIndex: 'userSex', key: 'userSex', width: 80, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
          </Fragment>
        )}
      },
      { title: '사번', dataIndex: 'orUserId', width: 120, align: 'center' },
      { title: '사원명', dataIndex: 'orUserNm', width: 150, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item !== undefined && item !== null) 
              ? item 
              : (record.userNm !== undefined && record.userNm !== null) ? record.userNm : ""}
          </Fragment>
        )}
      },
      { title: '상품명', dataIndex: 'orGdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'orGdSize', width: 100, align: 'center',
        render: (item, record, index) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.orEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'orCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'orGdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item !== undefined && item !== null && item !== '') &&
            (parseInt(item)*parseInt(record.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      }
    ];
    const columnsLG = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: 140, align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '구매/반품확정일', dataIndex: 'confirmDate', width: 140, align: 'center',
        render: (item, record) => {return(
          item !== undefined && item !== null &&
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '주문번호', dataIndex: 'orCartNo', width: 180, align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },
      { title: '주문상태', dataIndex: 'orStat', width: 140, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "2" && <Fragment>주문완료</Fragment>}
            {item === "4" && <Fragment>배송준비</Fragment>}
            {item === "5" && <Fragment>배송중</Fragment>}
            {item === "6" && <Fragment>구매확정</Fragment>}
            {item === "7" && <Fragment>반품신청</Fragment>}
            {item === "8" && <Fragment>반품승인</Fragment>}
            {item === "9" && <Fragment>반품반려</Fragment>}
          </Fragment>
        )}
      },
      { title: '소속', dataIndex: 'orCeNm', width: 160, align: 'center' },
      { title: '상품명', dataIndex: 'orGdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'orGdSize', width: 100, align: 'center',
        render: (item, record, index) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.orEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'orCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'orGdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item !== undefined && item !== null && item !== '') &&
            (parseInt(item)*parseInt(record.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      }
    ];
    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">대상기간</span> 
              <ConfigProvider locale={koKr}>
                <DatePicker.RangePicker
                  style={{ width: 270, marginRight: '20px' }}
                  format={'YYYY-MM-DD'}
                  allowClear={false}
                  defaultValue={[
                    moment(moment().subtract(1, 'month').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                    moment(moment().format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                  ]}
                  onChange={(date)=>{
                    onChangValue('strDate', date[0].format('YYYY-MM-DD'));
                    onChangValue('endDate', date[1].format('YYYY-MM-DD'));
                    this.onSearch();
                  }}
                />
              </ConfigProvider>
            </span>
            <CenterOptionList
              ceBranchCdValue={valCondition.ceBranchCd}
              ceCdValue={valCondition.ceCd}
              eBranchCdChange={(value)=>{
                onChangValue('ceBranchCd', value);
                onChangValue('ceCd', '');
                this.onSearch();
              }}
              ceCdfuncChange={(value)=>{
                onChangValue('ceCd', value);
                this.onSearch();
              }}
            />
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>{
              disSettleList(1, value);
            }}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          
          &nbsp;&nbsp;총 &nbsp;&nbsp;{pageInfo !== null && pageInfo.totalCnt}&nbsp;&nbsp; 건
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          총 주문액: &nbsp;&nbsp;
          {totalPrice !== undefined && totalPrice !== null &&
            totalPrice !== "" && totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} &nbsp;&nbsp;원
            <h4 style={{ color: 'red' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              ※정산관리는 구매확정/반품승인 일 기준입니다.
            </h4>
          <div className="button-right">
            <ul>             
              <li>
                {/* 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-SETTLE-LIST'}
                  schInfo={valCondition}
                />
              </li>
            </ul>
          </div>
        </div>
        
        <Table
          rowKey={(record)=>record.RNUM}
          rowClassName={(record)=>
            (record.orCnt !== undefined && record.orCnt !== null && parseInt(record.orCnt) < 0 && "red")
          }
          columns={cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG ? columns : columnsLG} 
          dataSource={settleList}
          pagination={false}
          scroll={{ x: 2030 }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>

      </Fragment>
    );
  }

}

export default withRouter(SettleList);